<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
      name: "App",
      components: {},
  };
</script>

<style>
  .b4014e33-99de-4bff-a040-79cf4526fd82 {
      fill: #333;
      fill-rule: evenodd;
  }
</style>
<style>
  .ff452229-05c2-4ff9-b426-bfc8edf0f91c {
      fill: #333;
  }
</style>
<style>
  .a29fadad-87cd-45dd-b870-cd004368b1e6 {
      fill: #333;
      fill-rule: evenodd;
  }
</style>
<style>
  .af59355c-1891-45e0-9269-0f4994d98bb7 {
      fill-rule: evenodd;
  }
</style>
<style>
  /*Tombon*/
  .content .elementor-button {
      color: var(--text-white);
      background-color: var(--btn-primary-bg);
      transition: background-color 0.3s ease;
  }
  .content .elementor-button:hover {
      background-color: var(--btn-primary-hover);
  }

  /*Text H2*/
  .content h2 {
      font-family: "Analogue", Times, serif;
      color: var(--primary-color);
  }

  /*Tanggal Event*/
  .content-date h2 {
      font-family: "Analogue", Times, serif;
      color: var(--primary-color);
  }

  /*Text P*/
  .content p {
      color: var(--primary-color);
  }
</style>

<style>
  .af59355c-1891-45e0-9269-0f4994d98bb7 {
      fill-rule: evenodd;
  }
</style>
